import { render, staticRenderFns } from "./u-input.vue?vue&type=template&id=fdbb9fe6&scoped=true&"
import script from "./u-input.vue?vue&type=script&lang=js&"
export * from "./u-input.vue?vue&type=script&lang=js&"
import style0 from "./u-input.vue?vue&type=style&index=0&id=fdbb9fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbb9fe6",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-input/u-input.vue"
export default component.exports